module.exports = __webpack_public_path__ + "static/media/linkimg6.77ba956c.jpg";